import React from 'react';
import { Hero } from '../components/Hero';
import { OpeningLead } from '../components/OpeningLead';
import { ForWhom } from '../components/ForWhom';
import { ProblemSection } from '../components/ProblemSection';
import { WhyOldSolutionsFail } from '../components/WhyOldSolutionsFail';
import { SolutionReveal } from '../components/SolutionReveal';
import { WhatIsIncluded } from '../components/WhatIsIncluded';
import { HonestPromise } from '../components/HonestPromise';
import { Pricing } from '../components/Pricing';
import { FAQ } from '../components/FAQ';
export function SalesPage() {
  return <div className="min-h-screen bg-[#FAF8F9] overflow-x-hidden" data-id="element-153">
      <div id="hero" data-id="element-154">
        <Hero data-id="element-155" />
      </div>
      <OpeningLead data-id="element-156" />
      <ForWhom data-id="element-157" />
      <ProblemSection data-id="element-158" />
      <WhyOldSolutionsFail data-id="element-159" />
      <SolutionReveal data-id="element-160" />
      <WhatIsIncluded data-id="element-161" />
      <HonestPromise data-id="element-162" />
      <Pricing data-id="element-163" />
      <FAQ data-id="element-164" />

      <footer className="bg-brand-text text-white/40 py-8 text-center text-sm" data-id="element-165">
        <div className="max-w-7xl mx-auto px-4" data-id="element-166">
          <p data-id="element-167">© 2026 Menopausia Sin Fogatas. Todos los derechos reservados.</p>
          <p className="mt-2 text-xs" data-id="element-168">
            Este producto no sustituye el consejo médico profesional.
          </p>
        </div>
      </footer>
    </div>;
}